import { useTheme } from "@emotion/react";
import React, { useContext } from "react";
import { CcRootContext } from "../conversionCenterRoot";
import { CcIcon } from "./ccIcon";

const CcLinkButton = ({ data, alternative, preview = false, ...props }) => {
  const ctx = useContext(CcRootContext);
  const theme = useTheme();

  const linkButtonStyle = (alternative) => ({
    backgroundColor: alternative ? "transparent" : theme.colors.white,
    border: 0,
    borderRadius: 3,
    boxShadow: alternative ? "none" : "0px 1px 5px rgba(0,0,0,0.2)",
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: alternative ? "auto" : 39,
    width: alternative ? "auto" : "100%",
    marginLeft: alternative ? "auto" : 0,
    padding: alternative ? 0 : "5px 16px",
    textAlign: "left",
    transition: "all .2s ease-in-out",
    "&:hover": {
      backgroundColor: alternative ? "transparent" : theme.colors.primary,
      color: alternative ? theme.colors.primary : theme.colors.white,
    },
  });

  const iconWrapperStyle = {
    display: "inline-block",
    flexShrink: 0,
    width: 20,
    marginRight: ".5em",
    "svg": {
      height: "auto",
      maxHeight: 20,
      width: "100%",
      maxWidth: "100%",
      "path": {
        transition: "fill .2s ease-in-out",
      },
    },
  };

  const icon = data.btnData?.icon || data.btnData?.iconName;

  const handleContextUpdate = (data) => {
    if(preview) return;
    ctx.updateContext({
      history: [...ctx.history, {
        activeComponentType: data.contentType,
        activeSpecialty: data.speciality,
        activeElementPosition: data.btnData.numberInOrder,
        viewId: data.id,
      }],
    });
  };

  return(
    <button
      key={data.id}
      type="button"
      onClick={() => handleContextUpdate(data)}
      css={linkButtonStyle(alternative)}
      {...props}
    >
      {icon !== "NoIcon" && (
        <span css={iconWrapperStyle}>
          {icon ? <CcIcon name={icon} /> : icon}
        </span>
      )}
      {data.btnData.buttonTitle || data.speciality}
    </button>
  )
};

export default CcLinkButton;
